import { combineReducers } from 'redux';

import optional from './optional';
import required from './required';

const checkboxGroups = combineReducers({
  optional,
  required,
});

export default checkboxGroups;
